import React from "react";
import "./homeredesign.css";
import WearToRepair from "../Showcasing/WearToRepair";
import spotlightImage from "../../../images/pulsojetbox.png";
import homepageherobanner from "../../../images/bannerherobox.jpeg"

import homepagebanner from "../../../images/homepgae-banner___backup.jpg"
// Product images
import PulseLavageImg from "../../../images/pulso-main-image.png";
import SuctionTubeImg from "../../../images/Orthopedic-Suction-tube.png";
import SurgicalGownImg from "../../../images/ArthroscopicShaver-Blade.png";
import SagittalBladeImg from "../../../images/Sagittal_Blade.png";

// Trusted images
import Trusted1 from "../../../images/trustedone.jpg";
import Trusted2 from "../../../images/healthcare-concept-clinic.jpg";
import Trusted3 from "../../../images/chiropractor-provides-aid-patient.jpg";

const flagshipProducts = [
  {
    title: "Pulse Lavage System",
    desc: "Clinically validated irrigation system for debridement",
    image: PulseLavageImg,
  },
  {
    title: "Orthopedic Suction Tube",
    desc: "Dual-filter, sterile, OR-ready suction line",
    image: SuctionTubeImg,
  },
  {
    title: "Arthroscopic Shaver Blade",
    desc: "Precision-Crafted, High-Performance Cutting, Sterile & Single-Use",
    image: SurgicalGownImg,
  },
  {
    title: "Sagittal Blade",
    desc: "Compatible with major systems, precision-tested",
    image: SagittalBladeImg,
  },
];

const highlights = [
  "DPIIT Recognized Startup",
  "MDR-Compliant Manufacturing",
  "Local Sourcing & Scalability",
  "300+ Private & Public Sector Hospitals",
];

export default function HomeRedsign() {
  return (
    <div className="homepage-wrapper">
      {/* Hero */}
       {/* <section
        className="homepage-hero"
        style={{
          backgroundImage: ` url(${homepageherobanner})`,
        }}
      >
        <div className="wraping-box-col-text">
        <h1 className="homepage-hero-title">Innovating Surgical Confidence</h1>
        <p className="homepage-hero-subtext">
          Infection control. Surgical precision. Smart solutions, built for
          healthcare systems like ours
        </p>
        <div className="homepage-hero-buttons">
          <a href="#products" className="homepage-btn-outline">
            View Products
          </a>
          <a
            href="https://pulsojet.sabiote.in/"
            className="homepage-btn-outline"
          >
            Explore Pulsojet
          </a>
          </div>
        </div>
      </section> */}
      <section className="homepage-hero">
  <img
    src={homepageherobanner}
    alt="Pulse Lavage Device"
    className="homepage-hero-image"
  />

  <div className="hero-content">
    <h1 className="homepage-hero-title">
      Innovating Surgical Confidence
    </h1>

    <p className="homepage-hero-subtext">
      Infection control. Surgical precision. Smart solutions, built for
      healthcare systems like ours
    </p>

    <div className="homepage-hero-buttons">
      <a href="#products" className="homepage-btn-outline">
        View Products
      </a>
      <a href="https://pulsojet.sabiote.in/" className="homepage-btn-outline">
        Explore Pulsojet
      </a>
    </div>
  </div>
</section>


      {/* Product Categories */}
      <WearToRepair />

      {/* Flagship Products */}
      <section id="products" className="homepage-products">
        <h2 className="homepage-section-title">
          Explore Our Flagship Products
        </h2>
        <div className="homepage-product-grid">
          {flagshipProducts.map(({ title, desc, image }, i) => (
            <div key={i} className="homepage-product-card">
              <img src={image} alt={title} className="homepage-product-image" />
              <h3 className="homepage-product-title">{title}</h3>
              <p className="homepage-product-desc">{desc}</p>
              <a href="products/surgical-consumables" className="homepage-product-link">
                Learn More →
              </a>
            </div>
          ))}
        </div>
      </section>

      {/* Innovation Spotlight */}
      <section className="homepage-spotlight">
        <div className="spotlight-image spot-left">
          <img src={spotlightImage} alt="Pulse Lavage Device" />
        </div>
        <div className="spotlight-content">
          <div className="spotlight-text">
            <h2 className="homepage-section-title">
              Pulse Lavage: A New Standard
            </h2>
            <p className="homepage-spotlight-text">
              Our first indigenous surgical irrigation system — clinically
              validated, locally manufactured, and export-ready.
            </p>
            <a
              href="https://pulsojet.sabiote.in/"
              className="homepage-btn-primary"
              target="_blank"
              rel="noopener noreferrer"
            >
              Discover Pulsojet
            </a>
          </div>

          <div className="spotlight-image">
            <img src={spotlightImage} alt="Pulse Lavage Device" />
          </div>
        </div>
      </section>

      {/* Trusted Institutions */}
      <section className="homepage-trusted-section">
        <h2 className="homepage-section-title">
          Trusted in Surgery. Built for India.
        </h2>
        <p className="homepage-resources-desc">
          Validated by top hospitals and government health schemes including
          CGHS, ESIC, and state procurement bodies.
        </p>

        <div className="trusted-logos-container">
          <img src={Trusted1} alt="Trusted Image 1" className="trusted-logo" />
          <img src={Trusted2} alt="Trusted Image 2" className="trusted-logo" />
          <img src={Trusted3} alt="Trusted Image 3" className="trusted-logo" />
        </div>
      </section>

      {/* Why Sabiote */}
      <section className="homepage-why-section">
        <h2 className="homepage-section-title">Why Choose Sabiote?</h2>
        <div className="homepage-why-grid">
          {highlights.map((text, i) => (
            <div key={i} className="homepage-why-card">
              <p>{text}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Resources */}
      <section className="homepage-resources">
        <h2 className="homepage-section-title">Need Brochures or IFUs?</h2>
        <p className="homepage-resources-desc">Get in touch with our sales representative</p>
        <a href="/contact" className="homepage-btn-primary">
          Go to Resources
        </a>
      </section>
    </div>
  );
}
